import LenderPageTemplate from '@/components/shared/LenderPageTemplate'

const PSAFinancePage = () => {
  return (
    <LenderPageTemplate
      lenderName="PSA"
      slug="/lenders/mis-sold-psa-car-finance"
      seoImage=""
      seoImageAlt=""
      aiOverview=""
    />
  )
}

export default PSAFinancePage
